import { render, staticRenderFns } from "./AddPartnership.vue?vue&type=template&id=2afc49a4"
import script from "./AddPartnership.vue?vue&type=script&lang=js"
export * from "./AddPartnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports